'use strict';

//Utilities
var EventEmitter = require('events').EventEmitter;
var assign = require('object-assign');
var _ = require('lodash');
var AccountTypes = require('../utils/AccountTypes.js');
var Validators = require('../utils/Validators.js')
var Products = require('../utils/Products.js');

//Component
var AppDispatcher = require('../core/AppDispatcher.jsx');

//Constants
var ApplicationConstants = require('../constants/ApplicationConstants.js');
var OnlineAccessConstants = require('../constants/OnlineAccessConstants.js');
var YesNoValues = ApplicationConstants.YesNoValues;
var ApplicationActionTypes = ApplicationConstants.ActionTypes;
var ActionTypes = OnlineAccessConstants.ActionTypes;
var OnlineAccessData = OnlineAccessConstants.OnlineAccessData;
var OnlineAccessFieldErrorState = OnlineAccessConstants.OnlineAccessFieldErrorState;
var AccountTypeActionsTypes = require('../constants/AccountTypeConstants').ActionTypes;
var FormKeys = ApplicationConstants.FormKeys;
var ProductIds = ApplicationConstants.ProductIds;
var AccountTypeCodes = ApplicationConstants.AccountTypeCodes;
var YourDetailsActionTypes = require('../constants/YourDetailsConstants').ActionTypes;


//local variables
var _sectionName = 'Online Access';
var CHANGE_EVENT = 'change';
var _titleList;
var _errorList = [];
var _validationSummaryList = [];
var _accountType = '';
var _productId = '';
var _onlineAccess = [];
var _individualInvestor = {title: '', givenName: '', lastName: ''}
var _formKey;
var Content = require('../services/ContentService').getContent(); 

var _customAttributes = {
    pin: 'PIN',
    confirmPin: 'confirm PIN',
    secretQuestion: 'secret question',
    secretAnswer: 'secret answer',
    confirmSecretAnswer: 'confirm secret answer'
}

function initializeLocalVariables(){
    _errorList.length = 0;
    _validationSummaryList.length = 0;
    _onlineAccess.length = 0;
}

function indexToString(index){
    return (index === undefined) ? '' : index.toString();
}

function messageForSummary(index, message, multipleSectionId){
    return (multipleSectionId) ? multipleSectionId + ' - ' + message : message
}

var _onlineAccessFieldErrors = {
    pin: function (index, multipleSectionId) {
        if (_onlineAccess[index].fieldErrorState.pin.weakPin){
            return { clickable: _sectionName, message: messageForSummary(index, Content.summaryErrorMessages.weakPin, multipleSectionId), id: 'oapin' + indexToString(index) };
        } 
        else{
            return { clickable: _sectionName, message: messageForSummary(index, Content.summaryErrorMessages.pin, multipleSectionId), id: 'oapin' + indexToString(index) };
        }
    },
    confirmPin: function (index, multipleSectionId) { 
        return { clickable: _sectionName, message: messageForSummary(index, Content.summaryErrorMessages.confirmPin, multipleSectionId), id: 'oaconfirmPin' + indexToString(index) } 
    },
    confirmSecretAnswer: function (index, multipleSectionId) {
        return { clickable: _sectionName, message: messageForSummary(index, Content.summaryErrorMessages.confirmSecretAnswer, multipleSectionId), id: 'oaconfirmSecretAnswer' + indexToString(index) };
    }
};

var _onlineAccessValidateFunctions = {
    pin: function (index, id) {
        if (!Boolean(_onlineAccess[index].data.pin) || !Boolean(Validators.isNumeric(_onlineAccess[index].data.pin)) || _onlineAccess[index].data.pin.length !== 8){
            _errorList.push({ message: Content.inlineErrorMessages.pin, id: id || 'oapin' + indexToString(index), type: ApplicationConstants.messageTypes.error });
            return false;
        }
        return !_onlineAccess[index].fieldErrorState.pin.weakPin;
    },
    confirmPin: function (index, id) {
        if (_onlineAccess[index].data.confirmPin.length > 8){
            //let the validator handle this
            return true;
        }
        if (!(Boolean (_onlineAccess[index].data.confirmPin) && _onlineAccess[index].data.confirmPin === _onlineAccess[index].data.pin)){
            _errorList.push({ message: Content.inlineErrorMessages.confirmPin, id: id || 'oaconfirmPin' + indexToString(index), type: ApplicationConstants.messageTypes.error });
            return false;
        }
        return true;
    },
    confirmSecretAnswer: function (index, id) {
        if (!_onlineAccess[index].data.confirmSecretAnswer || _onlineAccess[index].data.confirmSecretAnswer.length > 50){
            //let the validator handle this
            return true;
        }
        if(_onlineAccess[index].data.confirmSecretAnswer.toLowerCase() !== _onlineAccess[index].data.secretAnswer.toLowerCase()){
            _errorList.push({ message: Content.inlineErrorMessages.confirmSecretAnswerInvalid, id: id || 'oaconfirmSecretAnswer' + indexToString(index), type: ApplicationConstants.messageTypes.error });
            return false;
        }
        return true;
    }
};

function setAccountType(accountType) {
    initializeLocalVariables();
    _accountType = accountType;
    _formKey = Products.getFormKey(_accountType, _productId);
    defaultInvestor();
}

function setProductId(productId) {
    initializeLocalVariables();
    _productId = productId;
    _formKey = Products.getFormKey(_accountType, _productId);
    if (productId === ProductIds.SUPER || productId === ProductIds.PENSION){
        _accountType = '';
        addInvestors(1)
    }
    else if (_accountType){
        defaultInvestor();
    }
}


function addInvestors(numberOfInvestors) {
    _.times(numberOfInvestors, function () {
        _onlineAccess.push({data: _.clone(OnlineAccessData), 
                            fieldErrorState: _.cloneDeep(OnlineAccessFieldErrorState),
                            individualInvestor: _.clone(_individualInvestor),
                            investorName: ''});
    });
}

function defaultInvestor() {
    switch (_formKey) {
        case FormKeys.JOINT_INVESTMENT:
        case FormKeys.JOINT_CHALLENGER:
        case FormKeys.JOINT_COMMINSURE:
        case FormKeys.COMPANY_INVESTMENT:
        case FormKeys.PARTNERSHIP_INVESTMENT:
        case FormKeys.TRUST_INVESTMENT:
        case FormKeys.SMSF_INVESTMENT:
        case FormKeys.TRUST_CHALLENGER:
        case FormKeys.SMSF_CHALLENGER:
        case FormKeys.TRUST_COMMINSURE:
        case FormKeys.SMSF_COMMINSURE:
            addInvestors(2);
            break;
        default:
            addInvestors(1);
            break;
    }
}

function getValidationRules(fieldId){
    var rules = {
        pin: 'digitExactLength:8',
        confirmPin: 'digitExactLength:8',
        secretQuestion: 'required',
        secretAnswer: 'required|maxLength:50',
        confirmSecretAnswer: 'required|maxLength:50'
    }

    if (!fieldId){
        return rules;
    }
    else if (!rules[fieldId]) {
        return null;
    }

    var rulesForField = {};
    rulesForField[fieldId] = rules[fieldId];
    return rulesForField; 
}

function updateOnlineAccess(fieldId, fieldValue, index){
    if (index === undefined){
        index = 0;
    }
    _onlineAccess[index].data[fieldId] = fieldValue;
}

function addAdditionalInvestors() {
    var investorLimit = AccountTypes.getInvestorLimit(_formKey);
    var additionalInvestors = _onlineAccess.length;
    switch (_formKey) {
        case FormKeys.PARTNERSHIP_INVESTMENT:
        case FormKeys.COMPANY_INVESTMENT:
        case FormKeys.TRUST_COMMINSURE:
        case FormKeys.TRUST_CHALLENGER:
        case FormKeys.TRUST_INVESTMENT:
        case FormKeys.SMSF_COMMINSURE:
        case FormKeys.SMSF_CHALLENGER:
        case FormKeys.SMSF_INVESTMENT:
            additionalInvestors--;
            break;
        default:
            break;
    }
    if (additionalInvestors < investorLimit) {
        addInvestors(1);
    }
}

function deleteInvestors(index){
    _onlineAccess.splice(index, 1);
    var isInvestorErrror = function(error, index){
        return error.id.match(index + '$');
    }
    _.remove(_errorList, function(error){ return isInvestorErrror(error, index); });

    for (var i = index + 1; i < _onlineAccess.length + 1; i++){
        var newError = _.filter(_errorList, function(error){ return isInvestorErrror(error, i); });
        var newIndex = i - 1;
        var oldIndexPattern = new RegExp(i + '$');
        _.forEach(newError, function(error){
            error.id = error.id.replace(oldIndexPattern, newIndex);
        });
    }
}

function validateField(fieldId, componentId, fieldValue, index) {
    if (index === undefined){
        index = 0;
    }
    if (_onlineAccess[index].data.grantOnlineAccess === YesNoValues.YES) {
        Validators.clearErrorListForField(_errorList, componentId);
        var isValid = (_onlineAccessValidateFunctions[fieldId]) ? _onlineAccessValidateFunctions[fieldId](index, componentId) : true;
        
        if (isValid){
            var rules = getValidationRules(fieldId);
            if (!rules) {
                return;
            }
            var validator = Validators.validateField(_onlineAccess[index].data, rules, _customAttributes, _errorList, fieldId, componentId);
            isValid = !validator.fails();
        }

        postInlineValidation(fieldId, isValid, index);
    }
    
}

function postInlineValidation(field, isValid, index){
    switch(field){
        case 'pin':
            _onlineAccess[index].fieldErrorState.pin.hasValidated = isValid;
            _onlineAccess[index].fieldErrorState.pin.weakPin = false;
            //Run confirm pin validation if user hase inputed
            if (_onlineAccess[index].data.confirmPin) {
                Validators.clearErrorListForField(_errorList, 'confirmPin');
                _onlineAccessValidateFunctions.confirmPin(index);
            }
            break;
        case 'secretAnswer':
            //Run confirm secret answer validation if user hase inputed
            if (_onlineAccess[index].data.confirmSecretAnswer) {
                Validators.clearErrorListForField(_errorList, 'confirmSecretAnswer');
                _onlineAccessValidateFunctions.confirmSecretAnswer(index);
            }
            break;
        default:
            break;
    }
}

function validateAll() {
    var user = window.NOA.userContext;
    if (!user.oin) {
        _validationSummaryList = [];
        var multipleSectionId = Products.getInvestorTypeMessageId(_accountType);
        _.times(_onlineAccess.length, function (index) {
            var investorId = '';
            if (_accountType === AccountTypeCodes.JOINT){
                investorId = multipleSectionId + (index + 1);
            }
            else if (index > 0) {
                investorId = multipleSectionId + index
            }
            
            if (_onlineAccess[index].data.grantOnlineAccess === YesNoValues.YES) {
                _.map(_onlineAccess[index].data, function(value, key){
                    //Manually validate each fiel due to the nature of validation
                    if (key === 'grantOnlineAccess') return;
                    var isValid = (_onlineAccessValidateFunctions[key]) ? _onlineAccessValidateFunctions[key](index) : true;

                    if (isValid){
                        var rules = getValidationRules(key);
                        if (!rules) return;
                        var validator = Validators.validateField(_onlineAccess[index].data, rules, _customAttributes, _errorList, key, 'oa' + key + index);
                        if (validator.fails()){
                            _validationSummaryList = _validationSummaryList.concat(
                                Validators.validateAll(_onlineAccess[index].data, rules, _customAttributes, 'oa{x}' + index, _sectionName, investorId));
                        }
                    }else{
                        return _validationSummaryList.push(_onlineAccessFieldErrors[key](index, investorId));
                    }

                });
            }
        });
    }
}

function setPinStrengthResult(result, index) {
    _onlineAccess[index].fieldErrorState.pin.weakPin = !result;
    _onlineAccess[index].fieldErrorState.pin.hasValidated = false;
    if (!result){
        _errorList.push({ message: Content.inlineErrorMessages.weakPinError, id: 'oapin' + indexToString(index), type: ApplicationConstants.messageTypes.error });
    }
}

function setPinStrengthErrorResult(index){
    _onlineAccess[index].fieldErrorState.pin.hasValidated = false;
}

function getIndividualInvestorName (investor){
    var title = _.find(_titleList.default, { id: parseInt(investor.title) });
    var investorName = (title) ? title.name : '';
    investorName += ' ' + investor.givenName + ' ' + investor.lastName;
    return investorName;
}

function getAdditionalInvestorIndex(index){
    if (index === undefined){
        index = 0;
    }
    switch (_formKey) {
        case FormKeys.PARTNERSHIP_INVESTMENT:
        case FormKeys.COMPANY_INVESTMENT:
        case FormKeys.TRUST_COMMINSURE:
        case FormKeys.TRUST_CHALLENGER:
        case FormKeys.TRUST_INVESTMENT:
        case FormKeys.SMSF_COMMINSURE:
        case FormKeys.SMSF_CHALLENGER:
        case FormKeys.SMSF_INVESTMENT:
            index++;
            break;
        default:
            break;
    }
    return index;
}
function saveIndividualInvestor(fieldId, fieldValue, index){
    if(_onlineAccess[index].individualInvestor.hasOwnProperty(fieldId)){
        _onlineAccess[index].individualInvestor[fieldId] = fieldValue;
        _onlineAccess[index].investorName = getIndividualInvestorName(_onlineAccess[index].individualInvestor);
    }
}

function updateYourDetailsData(fieldId, fieldValue, index) {
    if (index === 0 || index > 0){
        index = getAdditionalInvestorIndex(index);
        saveIndividualInvestor(fieldId, fieldValue, index);
        if(fieldId === 'corporateTrustee'){
            _onlineAccess[index].investorName = fieldValue;
        }
    }
    else {
        saveIndividualInvestor(fieldId, fieldValue, 0);
        if (fieldId === 'businessName'){
            _onlineAccess[0].investorName = fieldValue;
        }
    }
}

function loadTitleList(titles) {
    _titleList = titles;
}

function retrieveOnlineAccess(form) {
    if (form.yourDetails){
        var oaIndex = 0, list = [], defaultInv = 0;
        if (form.accountType !== ApplicationConstants.AccountTypeCodes.JOINT){
            _onlineAccess[oaIndex].data.grantOnlineAccess = form.yourDetails.grantOnlineAccess;
            defaultInv++;
            oaIndex++;
        }
        if (form.yourDetails.investorList && form.yourDetails.investorList.length > 0) {
            list = form.yourDetails.investorList;       
        }
        else if (form.yourDetails.trusteeList && form.yourDetails.trusteeList.length > 0) {
            list = form.yourDetails.trusteeList;
        }

        var additionalInvestors = list.length - (_onlineAccess.length - defaultInv);
        if (additionalInvestors > 0){
            addInvestors(additionalInvestors);    
        }
        
        for (var i = 0; i < list.length; i++, oaIndex++){
            _onlineAccess[oaIndex].data.grantOnlineAccess = list[i].grantOnlineAccess;
        }

        retrieveInvestorName(form.yourDetails);
    }
}

function retrieveInvestorName(yourDetails){
    if(yourDetails.businessName){
        updateYourDetailsData('businessName', yourDetails.businessName);
    }

    if (yourDetails.investorList && yourDetails.investorList.length > 0){
        _.times(yourDetails.investorList.length, function(index){
            retrieveIndividualInvestor(yourDetails.investorList[index], index);
        });
    }
    else if (yourDetails.trusteeList && yourDetails.trusteeList.length > 0){
        _.times(yourDetails.trusteeList.length, function(index){
            if (yourDetails.trusteeList[index].corporateTrustee) {
                updateYourDetailsData('corporateTrustee', yourDetails.trusteeList[index].corporateTrustee, index);
            }
            else{
                retrieveIndividualInvestor(yourDetails.trusteeList[index], index);
            }
        });
    }
}

function updateOnlineAccessForAdviserAuthority(isAdviserAuthorised) {
    if (isAdviserAuthorised) {
        _.times(_onlineAccess.length, function (index) {
            _onlineAccess[index].data.grantOnlineAccess = YesNoValues.YES;
        });
    }
}

function retrieveIndividualInvestor(yourDetails, index) {
    var investorIndex = getAdditionalInvestorIndex(index);
    saveIndividualInvestor('givenName', yourDetails.givenName, investorIndex);
    saveIndividualInvestor('lastName', yourDetails.lastName, investorIndex);
    saveIndividualInvestor('title', yourDetails.title, investorIndex);
}

function toggleIsLoadingComplete(index) {
    _onlineAccess[index].data.isLoadingComplete = !_onlineAccess[index].data.isLoadingComplete;
}

var OnlineAccessStore = assign({}, EventEmitter.prototype, {

    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },

    addChangeListener: function (callback) {
        this.on(CHANGE_EVENT, callback);
    },

    removeChangeListener: function (callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },

    getOnlineAccess: function () {
        return _onlineAccess;
    },

    getErrorList: function () {
        return _errorList;
    },

    getValidationSummary: function(){
        return _validationSummaryList;
    },

    isValid: function () {
        return _validationSummaryList.length === 0;
    },
    getOnlineAccessModel: function(){
        var data = [];
        _.map(_onlineAccess, function(value){
            data.push({grantOnlineAccess: value.data.grantOnlineAccess,
                        pin: value.data.pin,
                        secretQuestion: value.data.secretQuestion,
                        secretAnswer: value.data.secretAnswer});
        });
        return data;
    }
});

OnlineAccessStore.dispatchToken = AppDispatcher.register(function (action) {

    switch (action.actionType) {
        case ApplicationActionTypes.NEW_APPLICATION_INITIALISED:
            setProductId(action.productId);
            break;
        case ApplicationActionTypes.APPLICATION_RETRIEVE_SUCCESS:
            setProductId(action.applicationData.productId);
            setAccountType(action.applicationData.form.accountType);
            retrieveOnlineAccess(action.applicationData.form);
            break;
        case ActionTypes.SAVE_ONLINE_ACCESS:
            updateOnlineAccess(action.fieldId, action.fieldValue, action.index);
            validateField(action.fieldId, action.componentId, action.fieldValue, action.index);
            break;
        case ApplicationActionTypes.SEND_IS_ADVISER_AUTHORISED:
            updateOnlineAccessForAdviserAuthority(action.isAdviserAuthorised); 
            break;
        case ActionTypes.PIN_VALIDATED:
            setPinStrengthResult(action.data, action.index);
            toggleIsLoadingComplete(action.index);
            break;
        case ActionTypes.PIN_VALIDATED_ERROR:
            setPinStrengthErrorResult(action.index);
            toggleIsLoadingComplete(action.index);
            break;
        case YourDetailsActionTypes.UPDATE_YOUR_DETAILS:
            updateYourDetailsData(action.fieldId, action.fieldValue, action.index);
            break;
        case ApplicationActionTypes.LOAD_TITLE_LIST:
            loadTitleList(action.titles);
            break;
        case YourDetailsActionTypes.ADD_ADDITIONAL_INVESTORS:
            addAdditionalInvestors();
            break;
        case YourDetailsActionTypes.DELETE_TRUSTEE:
            deleteInvestors(action.index);
            break;
        case AccountTypeActionsTypes.SELECT_ACCOUNT_TYPE:
            setAccountType(action.accountType);
            break;
        case ApplicationActionTypes.VALIDATE_APPLICATION:
            validateAll();
            break;
        case ActionTypes.VALIDATE_PIN:
            toggleIsLoadingComplete(action.index);
            break;
        default:
            return true;
    }
    OnlineAccessStore.emitChange();
    return true;
});

module.exports = OnlineAccessStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/OnlineAccessStore.js